var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7493 0C22.9918 0 23.9992 1.00733 23.9992 2.24992V15.7501C23.9992 16.9926 22.9918 18 21.7493 18H2.24992C1.00733 18 0 16.9927 0 15.7501V2.24992C0 1.00733 1.00733 0 2.24992 0H21.7493ZM21.7493 1.49995H2.24992C1.83573 1.49995 1.49995 1.83573 1.49995 2.24992V15.7501C1.49995 16.1643 1.83573 16.5001 2.24992 16.5001H21.7493C22.1634 16.5001 22.4992 16.1643 22.4992 15.7501V2.24992C22.4992 1.83573 22.1634 1.49995 21.7493 1.49995ZM11.9971 3.62152C12.1961 3.62152 12.387 3.70046 12.5277 3.84118L15.7821 7.09557C16.075 7.38846 16.075 7.86334 15.7821 8.15623C15.4892 8.44912 15.0143 8.44912 14.7214 8.15623L12.7473 6.1821V13.6285C12.7473 14.0427 12.4116 14.3785 11.9973 14.3785C11.5831 14.3785 11.2473 14.0427 11.2473 13.6285V6.1839L9.27809 8.15583C8.9855 8.44892 8.51061 8.44922 8.21752 8.15653C7.92442 7.86394 7.92409 7.38906 8.21672 7.09597L11.4666 3.84155C11.6073 3.70073 11.7981 3.62152 11.9971 3.62152Z",
    fill: "#5E5E5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreen);
export default __webpack_public_path__ + "static/media/share_screen.cd54c216.svg";
export { ForwardRef as ReactComponent };